import restaurantReservationApi from '../../api/restaurant/restaurantReservationApi';
import {
  ApiResponse,
  Reservation,
  ReservationAvailability,
  ReservationPage,
  ReservationPageFilters,
  ReservationRequest,
} from '../../types/restaurant/RestaurantReservationTypes';

const queryString = (values: Record<string, string | number | undefined>) => {
  const query = new URLSearchParams();
  Object.entries(values).forEach(([key, value]) => {
    if (value !== undefined && value !== '') query.set(key, String(value));
  });
  return query.size ? `?${query.toString()}` : '';
};

const RestaurantReservationService = {
  listFiltered: async (branchId: number, filters: ReservationPageFilters) => {
    const query = new URLSearchParams({
      page: String(filters.page),
      size: String(filters.size),
    });
    query.append('sort', 'startsAt,asc');
    query.append('sort', 'id,asc');
    return (
      await restaurantReservationApi.addCustom(
        `/branches/${branchId}/filtered?${query.toString()}`,
        {
          active: filters.status ? null : filters.active,
          status: filters.status,
          dateFrom: filters.dateFrom || null,
          dateTo: filters.dateTo || null,
          tableId: filters.tableId,
          search: filters.search?.trim() || null,
        }
      )
    ).data as ReservationPage;
  },
  get: async (id: number) =>
    (await restaurantReservationApi.fetchById(id))
      .data as ApiResponse<Reservation>,
  availability: async (
    branchId: number,
    startsAt: string,
    durationMinutes: number,
    partySize?: number
  ) => {
    const suffix = queryString({ startsAt, durationMinutes, partySize });
    return (
      await restaurantReservationApi.fetchCustom(
        `/branches/${branchId}/availability${suffix}`
      )
    ).data as ApiResponse<ReservationAvailability[]>;
  },
  create: async (branchId: number, body: ReservationRequest) =>
    (await restaurantReservationApi.addCustom(`/branches/${branchId}`, body))
      .data as ApiResponse<Reservation>,
  update: async (id: number, body: ReservationRequest) =>
    (await restaurantReservationApi.modify(id, body))
      .data as ApiResponse<Reservation>,
  confirm: async (id: number) =>
    (await restaurantReservationApi.addCustom(`/${id}/confirm`, {}))
      .data as ApiResponse<Reservation>,
  cancel: async (id: number, reason: string) =>
    (await restaurantReservationApi.addCustom(`/${id}/cancel`, { reason }))
      .data as ApiResponse<Reservation>,
  noShow: async (id: number) =>
    (await restaurantReservationApi.addCustom(`/${id}/no-show`, {}))
      .data as ApiResponse<Reservation>,
};

export default RestaurantReservationService;
